<template>
  <div class="notes" ref="notesRef" @click="$event.stopPropagation()">
    <div class="header"></div>
    <textarea class="textarea" ref="myTextarea" v-model="newNote.content" placeholder="提出你的疑问，寻求大家的帮助..."></textarea>
    <div class="bottom-handler">
      <a-tooltip>
        <template #title>删除</template>
        <svg class="icon-svg icon-delete" @click="close()">
          <use xlink:href="#icon-delete" />
        </svg>
      </a-tooltip>
      <a-tooltip>
        <template #title>提交</template>
        <svg class="icon-svg icon-push" @click="pushReply()">
          <use xlink:href="#icon-fill-push" />
        </svg>
      </a-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'question-box',
  components: {},
  props: {
    newNoteId: String,
    userNote: Object,
  },
  data() {
    return {
      newNote: {
        content: ''
      },
      themeColor: '#666666'
    }
  },
  mounted() {
    this.newNote = this.userNote.notes.find(item => item.uid == this.newNoteId);
    //聚焦
    if (this.$refs.myTextarea) this.$refs.myTextarea.focus();

    //监听对话框外部点击
    window.addEventListener('mousedown', e => { this.hideBox(e) })
    //监听对话框外部点击
    window.addEventListener('blur', e => {
      if (document.activeElement && document.activeElement.nodeName.toLocaleLowerCase() == 'iframe') {
        this.close()
      }
    })
  },
  methods: {
    //关闭
    close() {
      this.userNote.notes = this.userNote.notes.filter(item => item.uid !== this.newNoteId);
      this.$emit('closeUpdate', true)
    },
    //推送疑问
    async pushReply() {
      let userNote = JSON.parse(JSON.stringify(this.userNote));
      let res = await this.$api.note.createOrUpdate(userNote);
      if (res.statusCode != 200) return this.$message.warning(res.message);

      if (res.data._id) this.$emit('newUserNote', res.data);
      setTimeout(() => {
        this.$emit('refreshList', this.newNote)
      }, 1);
    },
    //隐藏
    hideBox(e) {
      // 获取被点击的元素
      const clickedEl = e.target;
      const notesRef = this.$refs.notesRef;
      if (!clickedEl || !notesRef) return;
      if (!notesRef.contains(clickedEl)) this.close()
    },
  },
  beforeDestroy() {
    window.removeEventListener('mousedown', e => { this.hideBox(e) });
  }
}
</script>

<style scoped lang="scss">
@import "./add-question.scss";
</style>